<template>
    <card
        :background="disable ? 'lightgrey' : null"
        class="jc-space licence-item"
        border-color="gray-40"
    >
        <h5 class="mt-0 mb-2 lh-big bold">{{ title }}</h5>
        <div class="licence-item-action mb-3 wp-10">
            <progress-counter class="wp-10" :value="value" :total="total" v-if="!disable" />
            <template v-else>
                <a
                    href="javascript:;"
                    onclick="MySupport.getForm();"
                    v-if="enableSupport"
                    class="semibold fs-3 btn-small primary-50-bkg b-1-primary-100-hover br hover-primary-100-bkg white"
                >
                    {{ $l10n.__('Contacter un commercial') }}
                </a>
                <p v-else class="gray-80 lh-20 fs-3 m-0">
                    {{ $l10n.__("Vous n'avez aucune licence de ce type dans votre offre.") }}
                </p>
            </template>
        </div>
        <div class="licence-item-link flex-column jc-space">
            <p class="gray-60 mt-0 mb-2 leading-5">
                <slot></slot>
            </p>
            <CompassLink
                :label="$t.__('sellsyaccountmanager.LicenceItem.view_modules_list')"
                type="secondary"
                size="small"
                suffixIcon="external-link"
                :link="linkUrl"
                target="_blank"
            />
        </div>
    </card>
</template>

<script>
import Card from 'vcomponents/Card.vue';
import ProgressCounter from 'vcomponents/sellsyaccountmanager/ProgressCounter.vue';

export default {
    components: {
        Card,
        ProgressCounter,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        code: {
            type: String,
            required: true,
        },
        value: {
            type: Number,
            required: true,
        },
        total: {
            type: Number,
            required: true,
        },
        disable: {
            type: Boolean,
            required: false,
        },
        enableSupport: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    computed: {
        linkUrl() {
            const baseUrl = 'https://go.sellsy.com/tous-nos-modules';
            let anchor = '/';
            switch (this.code) {
                case 'pack_prospecting_sale':
                    anchor = '#vente';
                    break;
                case 'pack_invoicing_management':
                    anchor = '#facturation';
                    break;
                default:
                    break;
            }

            return `${baseUrl}${anchor}`;
        },
    },
};
</script>

<style lang="scss" scoped>
.licence-item {
    // min-height: 190px;
    // height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
}

.licence-item-link {
    flex: 1 1 50%;
    margin-top: auto;
    overflow: visible;

    a {
        width: fit-content;
    }
}

.licence-item-action {
    min-height: 42px;
}

.leading-5 {
    line-height: 16px;
}

.btn-small {
    padding: 2px 12px;
    line-height: 20px !important;
}
</style>
